import template from "./modal.html";
import {
	filter,
	flatMap
} from "lodash";
import { EVENT_LOGOUT } from "constants.js";
import {
	FuzzySearcher, 
	FUZZY_OPTIONS 
} from "../../../utils/fuzzy-search";
import { ENTITY_TRANSLATION_KEYS } from "../../../services/i18nService";

export class Controller {
	lookup = null;
	table = null;
	identifierColumn = null;
	searcher = null;

	constructor($scope, eventBus, $sce, entityManager, api, $logger) {
		this._scope = $scope;
		this.$sce = $sce;
		this.eventBus = eventBus;
		this.entityManager = entityManager;
		this.api = api;
		this.$logger = $logger;
		this.ENTITY_TRANSLATION_KEYS = ENTITY_TRANSLATION_KEYS;

		this.table = {
			data: [],
			actions: {},
			sort: {},
			filter: (onlyMatchExact) => this.filter(onlyMatchExact),
			reset: () => this.reset(),
			filterBy: null
		};

		this.paginatorOptions = {};

		this.hasLicenses = false;

		this.searcher = new FuzzySearcher([], FUZZY_OPTIONS.ENTITY);
	}

	$onInit() {
		this.lookup = this.resolve.lookup;
		this.entityQueryConfiguration = this.lookup.entityQueryConfiguration;

		this.getClientDataFromField();
		this.loadClientDataIntoTable();

		this.entityTypes = this.lookup.entityTypes || [];
		this.showAdvancedSearch = !this.lookup.fieldId;

		if(this.lookup.fieldId) {
			this.entityQueryConfiguration = this.entityManager.allEntityConfigs[this.lookup.fieldId];
			this.entityTypes.push(this.entityManager.allEntityConfigs[this.lookup.fieldId].Friendly);

			if(this.entityManager.allEntityConfigs[this.lookup.fieldId].RelationshipType.Code !== "SELF") {
				this.entityTypes.push(this.entityManager.allEntityConfigs[this.lookup.fieldId].Primary);
			}
		}

		this.selectedEntityType = this.entityTypes[0];

		this.eventBus.register(EVENT_LOGOUT, () => { this.handleSelection(); }, this._scope);
	}

	getClientDataFromField() {
		this.clientData = this.lookup.fieldId && [...filter(this.entityManager.allEntities[this.lookup.fieldId], e => e.isFriendly)];
		if(!this.clientData && this.entityQueryConfiguration?.RelationshipType?.Code) {
			const eqc = this.entityQueryConfiguration;
			this.clientData = [...this.entityManager.userScopedEntities[eqc.Friendly.Type.Code][eqc.Primary.Type.Code][eqc.RelationshipType.Code].filter(e => e.isFriendly)];
		}
	}

	loadClientDataIntoTable() {
		this.table.data = this.clientData.map((source) => {
			const primaryIdentifiers = flatMap(source.Entities, (e) => {
				const entityIdentifiers = (e.Entity && filter(e.Entity.Identifiers, (i) => i.Type.Code !== "TOKEN")) || [];
				return entityIdentifiers;
			}) || [];
			const friendlyIdentifiers = source.Identifiers || [];

			const identifiers = (friendlyIdentifiers).concat(primaryIdentifiers);

			const item = { ...source };

			if(identifiers.length) {
				this.identifierColumn = true;

				const extraData = identifiers.map(id => {
					return `<small><b>${id.Type.Name}</b>: ${id.Value}</small>`;
				});

				const dataBlock = `<div>
					${extraData.join("")}
				</div>`;

				item.identifierDisplay = this.$sce.trustAsHtml(dataBlock);
			}

			if(item.Entities && !this.entityManager.isEntitySelf(item)) {
				this.hasLicenses = true;
				const codes = [];
				item.Entities.forEach(e => {
					if(e.Entity.Code) {
						codes.push(e.Entity.Code);
					}
				});

				item.entityDisplay = codes.join(", ");
			}

			return item;
		});

		this.searcher.setCollection([ ...this.table.data ]);

		if(this.lookup.options?.isFavoriteEnabled) {
			this.table.data = this.table.data.filter(d => d.IsFavorite);
		}

		this.paginatorOptions = {
			...this.paginatorOptions, 
			totalItems: this.table.data.length
		};
	}

	filter(onlyMatchExact = false) {
		let results = [];
		if(this.table.filterBy) {
			results = this.searcher.search(this.table.filterBy, {
				logger: this.$logger.debug.bind(this.$logger),
				exactOnly: onlyMatchExact,
				tokenizeInput: onlyMatchExact !== true
			});
		}

		this.table.data = results;
		this.paginatorOptions = {
			...this.paginatorOptions, 
			totalItems: this.table.data.length
		};
	}


	// **** FUTURE LAZY ENTITIES ****
	// searchOnline() {
	// 	let entityType = this.selectedEntityType.Type.Code;
	// 	let queryOptions = {type: entityType, find: this.table.filterBy};

	// 	if(this.selectedIdentitiferType){
	// 		queryOptions.identifierType = this.selectedIdentitiferType.code;
	// 		queryOptions.identifierValue = this.table.filterBy;
	// 	}

	// 	if(this.selectedClassification){
	// 		queryOptions.classification = this.selectedClassification.Code;
	// 	}

	// 	let url = FORM_ENTITIES(this.entityManager.form.Id, queryOptions);

	// 	this.api.get(url).then(formEntities => {
	// 		this.table.data = formEntities.Results;
	// 	});
	// }

	// clearIdentifierSearch() {
	// 	this.selectedIdentitiferType = null;
	// }

	// clearClassificationSearch() {
	// 	this.selectedClassification = null;
	// }
	// *************************************

	reset() {
		this.table.filterBy = null;
		this.table.filter();
	}

	handleSelection(result) {
		this.modalInstance.close(result);
	}
	
	handleSelectionKeyUp(event, result) {
		if((event.keyCode == 13) || (event.keyCode == 32)) {
			this.modalInstance.close(result);
		}
	}
}

export default angular
	.module("vesl.components.field-helpers.advanced-search-modal", [])
	.component("advancedSearchModal", {
		controller: Controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	}).name;
